
const safeStringify = (obj: unknown) => {
  try {
    return JSON.stringify(obj);
  } catch (error) {
    return '';
  }
};
// 将对象的所有属性值转换为字符串
export function convertAttributesToString(attributes: Record<string, unknown>): Record<string, string> {
  const result: Record<string, string> = {};
  for (const [key, value] of Object.entries(attributes)) {
    result[key] = value !== undefined && value !== null ? typeof value === 'object' ? safeStringify(value) : String(value) : '';
  }
  return result;
}